import React from 'react'
import PT from 'prop-types'
import ConfirmModal from 'components.v2/Modal/ConfirmModal'

function OrderPartyLeaveConfirmation({
  isLoading = false,
  isOpen = false,
  onCancel = () => {},
  onConfirm = () => {},
}) {
  if (!isOpen) return null
  return (
    <ConfirmModal
      confirmText="Leave"
      description="Are you sure? We will notify the the host the you've left the party."
      isDisabled={isLoading}
      isLoading={isLoading}
      isOpen
      onCancel={onCancel}
      onConfirm={onConfirm}
      title="Leave the party?"
    />
  )
}

OrderPartyLeaveConfirmation.propTypes = {
  isLoading: PT.bool,
  isOpen: PT.bool,
  onCancel: PT.func,
  onConfirm: PT.func,
}

OrderPartyLeaveConfirmation.defaultProps = {
  isLoading: false,
  isOpen: false,
  onCancel: () => {},
  onConfirm: () => {},
}

export default OrderPartyLeaveConfirmation
